module.exports = __webpack_public_path__ + "img/new-items.0975a13d.png";